// Sewing-themed SVG pattern background component
// Low opacity decorative elements: scissors, bobbins, sewing machines, irons, pins, zips, needle and thread

export const SewingPattern = ({ className = "", opacity = 0.05 }) => {
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} style={{ opacity }}>
      <svg 
        className="w-full h-full" 
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 800 600"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <pattern id="sewingPattern" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
            {/* Scissors */}
            <g transform="translate(20, 20) scale(0.8)" fill="currentColor">
              <path d="M12 2C10.9 2 10 2.9 10 4C10 4.7 10.4 5.4 10.9 5.7L7 11.5C6.1 10.6 4.7 10.6 3.8 11.5C2.9 12.4 2.9 13.8 3.8 14.7C4.7 15.6 6.1 15.6 7 14.7L8.4 13.3L10.9 18.3C10.4 18.6 10 19.3 10 20C10 21.1 10.9 22 12 22C13.1 22 14 21.1 14 20C14 19.3 13.6 18.6 13.1 18.3L15.6 13.3L17 14.7C17.9 15.6 19.3 15.6 20.2 14.7C21.1 13.8 21.1 12.4 20.2 11.5C19.3 10.6 17.9 10.6 17 11.5L13.1 5.7C13.6 5.4 14 4.7 14 4C14 2.9 13.1 2 12 2Z"/>
            </g>
            
            {/* Thread Spool / Bobbin */}
            <g transform="translate(80, 30) scale(0.7)" fill="currentColor">
              <rect x="8" y="4" width="8" height="2" rx="1"/>
              <rect x="6" y="6" width="12" height="12" rx="2"/>
              <rect x="8" y="18" width="8" height="2" rx="1"/>
              <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            </g>
            
            {/* Sewing Machine */}
            <g transform="translate(140, 15) scale(0.6)" fill="currentColor">
              <path d="M4 18V20H20V18H18V16H20V14C20 12.9 19.1 12 18 12H14V8H16V6H14V4H10V6H8V8H10V12H6C4.9 12 4 12.9 4 14V16H6V18H4ZM8 14H16V16H8V14Z"/>
              <circle cx="12" cy="10" r="1"/>
            </g>
            
            {/* Iron */}
            <g transform="translate(30, 90) scale(0.65)" fill="currentColor">
              <path d="M21 6H16V4C16 2.9 15.1 2 14 2H10C8.9 2 8 2.9 8 4V6H3L5 20H19L21 6ZM10 4H14V6H10V4ZM7 18L6 8H18L17 18H7Z"/>
            </g>
            
            {/* Pin */}
            <g transform="translate(100, 100) scale(0.6)" fill="currentColor">
              <circle cx="12" cy="4" r="3"/>
              <rect x="11" y="7" width="2" height="14" rx="0.5"/>
            </g>
            
            {/* Zipper */}
            <g transform="translate(150, 80) scale(0.55)" fill="currentColor">
              <rect x="10" y="2" width="4" height="20" rx="1"/>
              <path d="M6 4L10 6V8L6 6V4Z"/>
              <path d="M6 8L10 10V12L6 10V8Z"/>
              <path d="M6 12L10 14V16L6 14V12Z"/>
              <path d="M6 16L10 18V20L6 18V16Z"/>
              <path d="M18 4L14 6V8L18 6V4Z"/>
              <path d="M18 8L14 10V12L18 10V8Z"/>
              <path d="M18 12L14 14V16L18 14V12Z"/>
              <path d="M18 16L14 18V20L18 18V16Z"/>
              <rect x="9" y="20" width="6" height="4" rx="1"/>
            </g>
            
            {/* Needle and Thread */}
            <g transform="translate(50, 150) scale(0.7)" fill="currentColor">
              <ellipse cx="12" cy="4" rx="2" ry="1"/>
              <rect x="11.5" y="5" width="1" height="16"/>
              <path d="M12 21L11 22L10 21L11 20Z"/>
              {/* Thread curve */}
              <path d="M14 4Q20 8 16 14Q12 20 18 22" fill="none" stroke="currentColor" strokeWidth="0.8" strokeDasharray="2,1"/>
            </g>
            
            {/* Another Scissors - rotated */}
            <g transform="translate(120, 150) rotate(45) scale(0.5)" fill="currentColor">
              <path d="M12 2C10.9 2 10 2.9 10 4C10 4.7 10.4 5.4 10.9 5.7L7 11.5C6.1 10.6 4.7 10.6 3.8 11.5C2.9 12.4 2.9 13.8 3.8 14.7C4.7 15.6 6.1 15.6 7 14.7L8.4 13.3L10.9 18.3C10.4 18.6 10 19.3 10 20C10 21.1 10.9 22 12 22C13.1 22 14 21.1 14 20C14 19.3 13.6 18.6 13.1 18.3L15.6 13.3L17 14.7C17.9 15.6 19.3 15.6 20.2 14.7C21.1 13.8 21.1 12.4 20.2 11.5C19.3 10.6 17.9 10.6 17 11.5L13.1 5.7C13.6 5.4 14 4.7 14 4C14 2.9 13.1 2 12 2Z"/>
            </g>
            
            {/* Small Bobbin */}
            <g transform="translate(170, 140) scale(0.5)" fill="currentColor">
              <rect x="8" y="4" width="8" height="2" rx="1"/>
              <rect x="6" y="6" width="12" height="12" rx="2"/>
              <rect x="8" y="18" width="8" height="2" rx="1"/>
            </g>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#sewingPattern)" className="text-pockett-purple"/>
      </svg>
    </div>
  );
};

export default SewingPattern;
